// src/pages/SystemResources/styles.js — painel de hardware do servidor (super)
import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const dark = t.mode === "dark";
  // no escuro o tom "fg" dos selos é o que tem contraste sobre a trilha
  const tone = (key, solid) => (dark ? t.status[key].fg : solid);
  return {
    scroll: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      paddingBottom: 16,
      ...theme.scrollbarStyles,
    },
    cards: {
      flex: "none",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 12,
    },
    grid: {
      flex: "none",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(320px, 100%), 1fr))",
      gap: 16,
      alignItems: "start",
    },
    actions: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" },
    meta: { fontSize: 12, color: t.textSecondary, whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" },
    autoLabel: { margin: 0, "& .MuiFormControlLabel-label": { fontSize: 13, color: t.textSecondary } },
    stack: { display: "flex", flexDirection: "column", gap: 16, minWidth: 0 },
    rows: { margin: 0, padding: 0, display: "flex", flexDirection: "column", minWidth: 0 },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 12,
      padding: "9px 0",
      fontSize: 13,
      minWidth: 0,
      borderTop: `1px solid ${t.lineRow}`,
      "&:first-child": { borderTop: 0, paddingTop: 0 },
      "&:last-child": { paddingBottom: 0 },
    },
    rowLabel: { color: t.textSecondary, flex: "0 0 auto", margin: 0 },
    rowValue: {
      margin: 0,
      color: t.text,
      fontWeight: 500,
      fontVariantNumeric: "tabular-nums",
      textAlign: "right",
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    barBlock: { display: "flex", flexDirection: "column", gap: 6, minWidth: 0 },
    barHead: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 12,
      fontSize: 13,
      color: t.text,
      minWidth: 0,
    },
    barLabel: { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    barPct: { flex: "none", fontWeight: 600, fontVariantNumeric: "tabular-nums" },
    bar: {
      height: 8,
      borderRadius: t.radius.pill,
      backgroundColor: dark ? t.line : t.lineRow,
      "& .MuiLinearProgress-bar": { borderRadius: t.radius.pill },
    },
    barOk: { "& .MuiLinearProgress-bar": { backgroundColor: tone("ok", t.semantic.success) } },
    barWarn: { "& .MuiLinearProgress-bar": { backgroundColor: tone("warn", t.semantic.warning) } },
    barCrit: { "& .MuiLinearProgress-bar": { backgroundColor: tone("down", t.semantic.error) } },
    barNeutral: { "& .MuiLinearProgress-bar": { backgroundColor: t.textMuted } },
    pctWarn: { color: tone("warn", t.status.warn.fg) },
    pctCrit: { color: tone("down", t.status.down.fg) },
    barHint: { fontSize: 12, color: t.textSecondary, fontVariantNumeric: "tabular-nums" },
    diskMount: { fontWeight: 600 },
    diskFs: { fontSize: 12, color: t.textSecondary, marginLeft: 6 },
    empty: { padding: "12px 0", textAlign: "center", color: t.textSecondary, fontSize: 13 },
    skeletonCard: { borderRadius: t.radius.md },
  };
});

export default useStyles;
